import { Events, EventTemplate } from '@ess/jg-rule-executor';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { GetModuleEventTemplates_moduleEventTemplates } from '@src/app/generated/GetModuleEventTemplates';
import { EventTemplateInput } from '@src/app/generated/globalTypes';

export class PortalEventTemplate extends EventTemplate implements ToJsonInputTranslatable {
  static fromGql(gql: GetModuleEventTemplates_moduleEventTemplates): PortalEventTemplate {
    return new PortalEventTemplate(
      gql.id,
      new Events(
        gql.events.onAttach,
        gql.events.onDelete,
        gql.events.onCreated,
        gql.events.onChange,
      ),
      gql.name
    );
  }

  toGqlInput(): EventTemplateInput {
    return {
      name: this.name,
      events: this.events,
    };
  }
}
